// extracted by mini-css-extract-plugin
module.exports = {"container":"addMember_container__1d5Za","content":"addMember_content__23Bnf"};